// Port of api/fuel/app/classes/insights/hindex/durations.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'durations',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: ['duration'],
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}
        if (!owner.get_count_plays || !owner.get_count_plays()) return {}

        var index = (vars && vars.index !== undefined) ? vars.index : 0
        var durationType = (filter && filter.duration) ? filter.duration : 'range'

        var collectionIndex = this._data.current.get_index_level()

        if (detail) {

            var where = ''
            if (index === false) index = 0

            if (durationType === 'range') {
                where = 'CAST(g.game_time_min / 10 AS INTEGER) <= ' + index + ' AND CAST(g.game_time_max / 10 AS INTEGER) >= ' + index
            } else if (durationType === 'min') {
                where = 'CAST(g.game_time_min / 10 AS INTEGER) = ' + index
            } else if (durationType === 'max') {
                where = 'CAST(g.game_time_max / 10 AS INTEGER) = ' + index
            } else if (durationType === 'mid') {
                where = 'CAST((((g.game_time_max - g.game_time_min) / 2) + g.game_time_min) / 10 AS INTEGER) ' + (index == 35 ? '>' : '') + '= ' + index
            }

            var raw = Util.query(
                'SELECT g.game_id AS g, g.game_time_max AS x, g.game_time_min AS n' +
                ' FROM collection c JOIN game g ON c.game_id = g.game_id' +
                ' WHERE c.user_id IN (' + Util.in(userIndex) + ')' +
                ' AND c.collection_own = 1' +
                ' AND c.collection_expansion = 0' +
                ' AND g.game_time_min > 0' +
                ' AND g.game_time_max > 0' +
                ' AND g.game_id IN (' + Util.in(collectionIndex) + ')' +
                ' AND ' + where +
                ' GROUP BY g.game_id' +
                ' ORDER BY g.game_sortname ASC'
            )

            var games = []
            for (var i = 0; i < raw.length; i++) {
                this._references.games.push(parseInt(raw[i].g, 10))
                games.push({
                    id: parseInt(raw[i].g, 10),
                    min: parseInt(raw[i].n, 10),
                    max: parseInt(raw[i].x, 10)
                })
            }

            return {
                games: games
            }

        } else {

            var durations = []
            for (var d = 0; d < 36; d++) {
                durations.push(0)
            }

            var rawData = Util.query(
                'SELECT g.game_time_min as n, g.game_time_max as x' +
                ' FROM collection c JOIN game g ON c.game_id = g.game_id' +
                ' WHERE c.user_id IN (' + Util.in(userIndex) + ')' +
                ' AND g.game_id IN (' + Util.in(collectionIndex) + ')' +
                ' AND c.collection_own = 1' +
                ' AND c.collection_expansion = 0' +
                ' GROUP BY g.game_id'
            )

            for (var ri = 0; ri < rawData.length; ri++) {
                var item = rawData[ri]

                if (item.n && item.x) {
                    var min = Math.floor(item.n / 10)
                    var max = Math.floor(item.x / 10)

                    if (min > 35) min = 35
                    if (max > 35) max = 35

                    if (durationType === 'range') {
                        for (var r = min; r <= max; r++) {
                            durations[r]++
                        }
                    } else if (durationType === 'min') {
                        durations[min]++
                    } else if (durationType === 'max') {
                        durations[max]++
                    } else if (durationType === 'mid') {
                        var mid
                        if (parseInt(item.n, 10) !== parseInt(item.x, 10)) {
                            mid = ((item.x - item.n) / 2) + parseInt(item.n, 10)
                        } else {
                            mid = parseInt(item.n, 10)
                        }
                        mid = Math.floor(mid / 10)
                        if (mid > 35) mid = 35
                        durations[mid]++
                    }
                }
            }

            return {
                durations: durations
            }

        }

    }
})
